<template>
  <div class="saved-items">
    <div class="top-section">
      <h2>כאן אנחנו שומרים את מה שאהבת</h2>
      <div class="columns is-centered saved-items-filter">
        <div>
          <a :class="cls(0)" href="#" @click.prevent="setSelected(0)">הכל</a>
        </div>
        <div>
          <a :class="cls(1)" href="#" @click.prevent="setSelected(1)"
            >שיעורים</a
          >
        </div>
        <div>
          <a :class="cls(2)" href="#" @click.prevent="setSelected(2)">סדרות</a>
        </div>
        <div>
          <a :class="cls(3)" href="#" @click.prevent="setSelected(3)"
            >תוכניות אימונים</a
          >
        </div>
        <div>
          <a :class="cls(4)" href="#" @click.prevent="setSelected(4)">מורים</a>
        </div>
      </div>
    </div>

    <div class="playlist-controls container">
      <router-link class="playlist-controls" :to="{ name: 'playlists' }">
        <i :class="createPlaylistIcon"></i>
        {{ createPlaylistLabel }}
      </router-link>
      <select-playlist
        v-if="$store.state.user.playlists.length > 0"
      ></select-playlist>
    </div>

    <div style="margin-bottom: 1rem">
      <videos :videos="itemsToShow"></videos>
    </div>

    <transition name="fade">
      <div v-if="selected === 0 || selected === 4">
        <teachers :teachers="$store.state.user.myTeachers"></teachers>
      </div>
    </transition>
  </div>
</template>

<script>
import Videos from "@/components/Videos.vue";
import Teachers from "@/components/teachers/Teachers.vue";
import SelectPlaylist from "@/components/playlists/selectPlaylist.vue";

export default {
  components: {
    Videos,
    Teachers,
    SelectPlaylist,
  },
  data() {
    return {
      selected: 0,
    };
  },
  methods: {
    cls(selected) {
      if (selected == this.selected) {
        return "saved-filter-item active";
      }
      return "saved-filter-item";
    },
    setSelected(selected) {
      this.selected = selected;
    },
  },
  computed: {
    videoList() {
      return this.$store.state.videos;
    },
    myvideos() {
      const vidArray = this.$store.state.user.myVideos;

      const arr = this.videoList.filter(v => vidArray.includes(`${v.id}`));
      return arr;
    },
    videoCollections() {
      let arr = [];
      arr = this.$store.state.series.filter(
        s =>
          this.$store.state.user.mySeries.indexOf(`${s.id}`) > -1 &&
          s.parent !== `10`
      );
      return arr;
    },
    seriesObjects() {
      const arr = this.$store.state.series.filter(
        s =>
          this.$store.state.user.mySeries.indexOf(`${s.id}`) > -1 &&
          s.parent === `10`
      );
      return arr;
    },
    allItems() {
      let output = [];
      let series = [];
      [...this.videoCollections, ...this.seriesObjects].forEach(s => {
        const videos = s.videoItems.split("||");
        if (this.videoList.length > 0) {
          videos.every(v => {
            const full = this.videoList.filter(
              vid => vid.id === parseInt(v, 10)
            )[0];
            series.push({
              id: s.id,
              pagetitle: s.pagetitle,
              image: full.ch,
              current: full.current,
              teacher: full.videoTeacher,
              description: s.description,
              level: full.videoLvl,
              videoRating: full.videoRating,
              videoDuration: full.videoDuration,
              publishedon: full.publishedon,
              type: "series",
              parent: s.parent,
            });
            return false;
          });
        }
      });

      if (this.$store.state.user.currentPlaylist.id === "0") {
        output = [...this.myvideos, ...series];
        return output;
      } else {
        let playlistVideos = [];
        let playlistSeries = [];
        playlistVideos = this.myvideos.filter(item =>
          this.$store.state.user.currentPlaylist.videos.includes(`${item.id}`)
        );

        series.forEach(item => {
          if (item.parent === "10") {
            if (
              this.$store.state.user.currentPlaylist.collections.includes(
                `${item.id}`
              )
            ) {
              playlistSeries.push(item);
            }
          } else {
            if (
              this.$store.state.user.currentPlaylist.series.includes(
                `${item.id}`
              )
            ) {
              playlistSeries.push(item);
            }
          }
        });
        return [...playlistVideos, ...playlistSeries];
      }
    },
    itemsToShow() {
      if (this.selected === 1) {
        return this.allItems.filter(item => item.type !== "series");
      }
      if (this.selected === 2) {
        return this.allItems.filter(
          item => item.type === "series" && item.parent !== "10"
        );
      }
      if (this.selected === 3) {
        return this.allItems.filter(
          item => item.type === "series" && item.parent === "10"
        );
      }
      if (this.selected === 4) {
        return [];
      }

      return this.allItems;
    },
    createPlaylistLabel() {
      if (this.$store.state.user.playlistSelected !== "0") {
        return "עריכת פלייליסט";
      }
      return "יצירת פלייליסט";
    },
    createPlaylistIcon() {
      if (this.$store.state.user.playlistSelected !== "0") {
        return "mdi mdi-pencil-circle-outline";
      }
      return "mdi mdi-plus-circle-outline";
    },
  },
};
</script>

<style lang="scss">
.saved-items {
  h2 {
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }
  .columns {
    justify-content: flex-start;
  }
  .video-item {
    margin: 0 0 15px 15px;
  }
  .teachers {
    text-align: right;
  }
  .container {
    padding-top: 30px;
  }
}
.saved-items-filter {
  div {
    padding: 1rem;
    .saved-filter-item {
      font-weight: bold;
      color: #000000;
      font-size: 1.1rem;
    }
    .saved-filter-item.active {
      color: #e97575;
    }
  }
}

.playlist-controls {
  display: flex;
  a {
    color: #838383;
    margin-left: 1rem;
  }
  select {
    color: #838383;
    background-color: transparent;
    border: 0;
    font-size: 1rem;
    font-weight: normal;
    font-family: "Heebo", sans-serif;
  }
}
</style>